// @ts-nocheck
import React from "react";
import FormInput from "../Componentes/FormInput";
import Adjuntos from "../Difusiones/Componentes/Adjuntos";
import { FormSelect } from "../Componentes/FormSelect";
import { MAX_SIZE_FILES_osticket } from "../Contantes/Constantes";
import FormInputMultiline from "../Componentes/FormInputMultiline";

const STU = (props) => {
  const { value, setValue, problemas } = props;

  const onChange = (e) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeProblemas = async (e) => {
    setValue({
      ...value,
      problema: e.target.value,
    });
  };

  const agregarAdjuntos = async (file) => {
    let e = {
      target: {
        name: "adjuntos",
        value: file,
      },
    };
    onChange(e);
  };

  return (
    <>
      <FormSelect
        name="tipoProblema"
        label="Tipo de Problema"
        selectedValue={value.problema}
        onChange={onChangeProblemas}
        items={problemas}
      />
      <FormInput
        name="asunto"
        label="Asunto"
        value={value.asunto}
        onChange={onChange}
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
        fullWidth
      />
      <FormInput
        name="nroInterno"
        label="Numero de Interno"
        value={value.nroInterno}
        onChange={onChange}
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
      />
      <FormInput
        name="oficina"
        label="Numero de Oficina"
        value={value.oficina}
        onChange={onChange}
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
      />
      <FormInput
        name="inventario"
        label="Inventario"
        value={value.inventario}
        onChange={onChange}
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
      />
      <FormInputMultiline
        name="descripcion"
        label="Descripcion"
        value={value.descripcion}
        onChange={onChange}
        // onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault()}}
      />
      <div>
        <Adjuntos
          size={MAX_SIZE_FILES_osticket}
          name="adjuntos"
          files={value.adjuntos}
          agregarAdjuntos={agregarAdjuntos}
        />
      </div>
    </>
  );
};
export default STU;
